import utils from "Sources/utils/utils";
import request from "Sources/services/request";

let MissionService = {};

((MissionService) =>
{
  MissionService.getMission = function(key)
  {
    return request.get({
      url:  utils.getServiceUrl("/missions/" + key),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then(MissionService.onServiceComplete);
  };

  MissionService.getMissionsForUser = function()
  {
    return request.get({
      url:  utils.getServiceUrl("/missions"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then(MissionService.onServiceComplete);
  };

  MissionService.createMission = function(missionObj)
  {
    return request.post({
      url:  utils.getServiceUrl("/missions"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
      data: missionObj
    })
      .then(MissionService.onServiceComplete);
  };

  MissionService.updateMission = function(missionObj)
  {
    return request.put({
      url:  utils.getServiceUrl("/missions/" + missionObj.key),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
      data: missionObj
    })
      .then(MissionService.onServiceComplete);
  };

  MissionService.deleteMission = function(missionKey)
  {
    return request.delete({
      url:  utils.getServiceUrl("/missions/" + missionKey),
      cache: false
    })
      .then(MissionService.onServiceComplete);
  }

  MissionService.copyMission = function(missionKey)
  {
    return request.post({
      url:  utils.getServiceUrl("/missions/" + missionKey + "/copy"),
      cache: false
    })
      .then(MissionService.onServiceComplete);
  }

  MissionService.favoriteMission = function(missionKey)
  {
    return request.post({
      url:  utils.getServiceUrl("/missions/" + missionKey + "/favorite"),
      cache: false
    })
      .then(MissionService.onServiceComplete);
  };

  MissionService.unfavoriteMission = function(missionKey)
  {
    return request.post({
      url:  utils.getServiceUrl("/missions/" + missionKey + "/unfavorite"),
      cache: false
    })
      .then(MissionService.onServiceComplete);
  };

  MissionService.shareWithUser = function(missionKey, userKey)
  {
    return request.post({
      url:  utils.getServiceUrl("/missions/" + missionKey + "/share/user"),
      cache: false,
      data: {
        "user-key" : userKey
      }
    })
      .then(MissionService.onServiceComplete);
  };

  MissionService.shareWithSchool = function(missionKey, schoolKey)
  {
    return request.post({
      url:  utils.getServiceUrl("/missions/" + missionKey + "/share/school"),
      cache: false,
      data: {
        "school-key" : schoolKey
      }
    })
      .then(MissionService.onServiceComplete);
  };

  MissionService.unshareWithUser = function(missionKey, userKey)
  {
    return request.post({
      url:  utils.getServiceUrl("/missions/" + missionKey + "/unshare/user"),
      cache: false,
      data: {
        "user-key" : userKey
      }
    })
      .then(MissionService.onServiceComplete);
  };

  MissionService.unshareWithSchool = function(missionKey, schoolKey)
  {
    return request.post({
      url:  utils.getServiceUrl("/missions/" + missionKey + "/unshare/school"),
      cache: false,
      data: {
        "school-key" : schoolKey
      }
    })
      .then(MissionService.onServiceComplete);
  };

  MissionService.onServiceComplete = function (data)
  {
    if(utils.isNotNull(data) && data.result === "success" && data.data)
    {
      return data.data;
    }

    return null;
  }


})(MissionService);

module.exports = MissionService;



// WEBPACK FOOTER //
// ./app/js/services/mission-service.js